import { Snackbar, styled } from "@mui/material";

const StyledSnackbar = styled(Snackbar)({
  "& .MuiSnackbarContent-root": {
    backgroundColor: "var(--main-color)",
    color: "var(--text-primary)",
  },
});

export const SnackbarComponent = ({
  message,
  duration = 5000,
  open,
  handleClose,
  className,
}) => {
  return (
    <StyledSnackbar
      className={className}
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      message={message}
    ></StyledSnackbar>
  );
};
